import { lazy, Suspense } from 'react';
import LazyLoading from '../../components/LazyLoading';

export const LazyAdmin = lazy(() =>
  import(/* webpackChunkName: 'Admin' */ './index'),
);

export default function Admin(props) {
  return (
    <Suspense fallback={<LazyLoading />}>
      <LazyAdmin {...props} />
    </Suspense>
  );
}
